import { gql } from 'graphql-request'

const GET_PRODUCTS_COUNT = gql`
  query getProductsCount(
    $search: String
    $type: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $price_from: Int
    $price_to: Int
    $creator_id: bigint
    $creator_nickname: String
    $creator_slug: [String!]
    $product_ids: [bigint!]
  ) {
    products_aggregate(
      where: {
        _and: [
          { type: { _in: $type } }
          { status: { _eq: "active" } }
          { visible: { _eq: "true" } }
          {
            creator: {
              id: { _eq: $creator_id }
              slug: { _in: $creator_slug }
              nickname: { _eq: $creator_nickname }
              account_status: { _eq: "active" }
              deleted: { _neq: true }
              creator_category_id: { _in: $creator_categories }
            }
          }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              }
              {
                price: { price_subunit: { _gte: $price_from, _lte: $price_to } }
              }
            ]
          }
          {
            _or: [
              { type: { _eq: "Product::FansiExperience" } }
              {
                product_categories: {
                  product_category_id: { _in: $topic }
                  _or: { product_category_id: { _in: $product_categories } }
                }
              }
            ]
          }
          {
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export default GET_PRODUCTS_COUNT
